import React from 'react';

interface EpicProgressProps {
  todo: number;
  inProgress: number;
  done: number;
  /** A Done Epic's bar is green. */
  isEpicDone?: boolean;
}

/** How far an Epic's direct children have got. It never sets the Epic's own status. */
const EpicProgress: React.FC<EpicProgressProps> = ({ todo, inProgress, done, isEpicDone = false }) => {
  const total = todo + inProgress + done;
  const percent = total ? Math.round((done / total) * 100) : 0;

  return (
    <section className="mb-4 rounded-xl border border-primary-subtle bg-primary-light px-5 py-4">
      <div className="flex items-baseline justify-between gap-3">
        <p className="text-sm text-neutral-medium">
          <span className="mr-1.5 text-xl font-semibold text-neutral">
            {done} of {total}
          </span>
          child work items done
        </p>
        <span className="text-sm font-semibold tabular-nums text-neutral">{percent}%</span>
      </div>
      <div
        className="mt-3 h-2 overflow-hidden rounded-full bg-primary-subtle"
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={`h-full rounded-full ${
            isEpicDone ? 'bg-[#10B981]' : 'bg-gradient-to-r from-[#8B5CF6] to-[#3B82F6]'
          }`}
          style={{ width: `${percent}%` }}
        />
      </div>
      <div className="mt-3 flex flex-wrap gap-5 text-xs text-neutral-medium">
        <span>
          To Do <span className="font-semibold text-neutral">{todo}</span>
        </span>
        <span>
          In Progress <span className="font-semibold text-[#93C5FD]">{inProgress}</span>
        </span>
        <span>
          Done <span className="font-semibold text-[#34D399]">{done}</span>
        </span>
      </div>
    </section>
  );
};

export default EpicProgress;
